import { render, staticRenderFns } from "./IntroductionContent.vue?vue&type=template&id=51b71448&scoped=true"
import script from "./IntroductionContent.vue?vue&type=script&lang=js"
export * from "./IntroductionContent.vue?vue&type=script&lang=js"
import style0 from "./IntroductionContent.vue?vue&type=style&index=0&id=51b71448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b71448",
  null
  
)

export default component.exports